'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _buttonLocal = require('./button.local.css');

var _buttonLocal2 = _interopRequireDefault(_buttonLocal);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _spinner = require('../spinner');

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Used to attach click events, create links, trigger actions
 */


var Button = function Button(props) {
  var childComponent = typeof props.children === 'string' || typeof props.children === 'number' ? _react2.default.createElement('span', {
    className: _buttonLocal2.default.text
  }, props.children) : props.children;
  return _react2.default.createElement('button', {
    title: props.title,
    className: (0, _classnames2.default)(_buttonLocal2.default.base, _buttonLocal2.default[props.theme], _buttonLocal2.default[props.size], _buttonLocal2.default[props.color], props.block && _buttonLocal2.default.block, props.className, props.children ? null : _buttonLocal2.default.iconOnly),
    onClick: props.onClick,
    disabled: props.disabled || props.spinner,
    type: props.type,
    'aria-label': props.ariaLabel
  }, props.spinner && _react2.default.createElement('div', {
    className: (0, _classnames2.default)([_buttonLocal2.default.spinner, _buttonLocal2.default.inner])
  }, _react2.default.createElement(_spinner2.default, {
    className: _buttonLocal2.default.spinnerBase,
    size: 'small',
    color: 'currentColor'
  })), _react2.default.createElement('div', {
    className: (0, _classnames2.default)([_buttonLocal2.default.inner, props.spinner && _buttonLocal2.default.hidden])
  }, props.icon && _react2.default.createElement(_icon2.default, {
    icon: props.icon,
    className: (0, _classnames2.default)(_buttonLocal2.default.icon, props.iconClassName)
  }), childComponent));
};

Button.displayName = 'UIButton';
Button.defaultProps = {
  block: false,
  children: null,
  color: 'primary',
  disabled: false,
  spinner: false,
  icon: null,
  onClick: null,
  ariaLabel: null,
  size: 'medium',
  theme: 'normal',
  type: 'button'
};
Button.propTypes = {
  /**
   * Display the button as a block element
   */
  block: _propTypes2.default.bool,

  /**
   * String or element to be displayed inside button
   */
  children: _propTypes2.default.node,

  /**
   * ClassName will insert styles to override defaults
   */
  className: _propTypes2.default.string,
  // Can pass custom icon classname into the button to icon
  iconClassName: _propTypes2.default.string,

  /**
   * Specify a thematic color
   */
  color: _propTypes2.default.oneOf(['primary', 'primary-hc', 'secondary', 'grayscale', 'grayscale-hc', 'light', 'status--positive', 'status--warning', 'status--negative', 'status--positive-hc', 'status--warning-hc', 'status--negative-hc']),

  /**
   * HTML disabled state, non-interactive
   */
  disabled: _propTypes2.default.bool,

  /**
   * Show spinner instead of children
   */
  spinner: _propTypes2.default.bool,

  /**
   * Add an icon next to the text
   */
  icon: _propTypes2.default.string,

  /**
   * A function that is called on button click
   */
  onClick: _propTypes2.default.func,

  /**
   * an accessibility label for the button
   */
  ariaLabel: _propTypes2.default.string,

  /**
   * title attribute
   */
  title: _propTypes2.default.string,

  /**
   * Choose a size for the button
   */
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  theme: _propTypes2.default.oneOf(['normal', 'outline', 'contentOnly', 'boxyNormal', 'boxyLight', 'boxyOutline', 'boxyTight']),

  /**
   * HTML button type
   */
  type: _propTypes2.default.oneOf(['button', 'submit'])
};
exports.default = Button;